import React from 'react';
import { Button } from '../../../../../../base/components/Button';
import { Input } from '../../../../../../base/components/Forms/Input';
import { Icon } from '../../../../../../base/components/Icon';
import { useAppDispatch, useAppSelector, useRoutesWithLang } from '../../../../../../base/hooks';
import { __t } from '../../../../../../base/utils/t';
import { passwordRecoveryActions } from '../../../redux/slices/passwordRecoverySlice';
import { AuthRoutes as WorkerAuthRoutes } from '../../../../../../worker/units/authorization/routes';

import '../styles.scss';

export const VerificationMethod = () => {
    const dispatch = useAppDispatch();
    const {
        fields: { email },
        errors,
    } = useAppSelector((state) => state.recruiterAppPasswordRecovery);
    const workerAuthRoutes = useRoutesWithLang<typeof WorkerAuthRoutes>(WorkerAuthRoutes);

    const inputChangeHandler = (id: string, value: unknown) => {
        dispatch(passwordRecoveryActions.setField({ id, value }));
    };

    const recoverPasswordSubmitHandler = () => dispatch(passwordRecoveryActions.submitRecoverPassword());

    return (
        <div className='password-recovery'>
            <p className='password-recovery__title'>
                {__t('Мы вышлем на электронную почту код для  восстановления доступа.')}
            </p>
            <div className='password-recovery__form-item scroll-margin-for-fixed-header'>
                <p className='password-recovery__form-label'>{__t('E-mail, на которий вы регистрировались')}</p>
                <Input
                    value={email}
                    placeholder={__t('Введите адрес почты')}
                    onChange={(value: string) => inputChangeHandler('email', value)}
                    errors={errors?.email}
                />
            </div>
            <Button className='password-recovery__button' onClick={recoverPasswordSubmitHandler}>
                {__t('Отправить')}
            </Button>

            <a
                href={`${window.GLOBALS?.crossSiteBaseUrl}${workerAuthRoutes.Login}`}
                className='password-recovery__workers-link'
            >
                <Icon
                    icon='user-helmet-safety-solid'
                    color='highlight'
                    className='password-recovery__workers-link-icon'
                />
                {__t('Я ищу работу')}
            </a>
        </div>
    );
};
